import { on } from 'delegated-events'

function init() {
  const filters = document.querySelector('.explore-filters')
  const items = document.querySelectorAll('[data-tags]')

  if (!filters) {
    return
  }

  on('click', '.explore-filters [data-filter]', (e) => {
    document.querySelectorAll('.explore-filters [data-filter]').forEach((x) => x.setAttribute('aria-pressed', false))
    e.currentTarget.setAttribute('aria-pressed', true)

    const filter = e.currentTarget.dataset.filter

    if (filter === '_all_') {
      items.forEach((x) => x.classList.remove('hidden'))
    } else {
      items.forEach((x) => {
        x.classList.add('hidden')

        const tags = JSON.parse(x.dataset.tags)

        if (tags.includes(filter)) {
          x.classList.remove('hidden')
        }
      })
    }
  })
}

init()
